import request from "@/utils/request";
import { getAuthorizationHeader } from ".";

export async function getPublic(isValidOnly) {
  return (await request.get(
    `/coupons/public?isValidOnly=${isValidOnly}`
  )).data.data;
}

export async function getMine(isValidOnly) {
  return (await request.get(
    `/coupons/me?isValidOnly=${isValidOnly}`,
    getAuthorizationHeader()
  )).data.data;
}

export async function searchCoupons(couponIds) {
  return (await request.post("/coupons/search", couponIds)).data.data;
}